package com.esoris.kmpmoout.domaindata.expense

import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val expenseModule = module {

    singleOf(::ExpenseRepositoryImpl)
        .bind<ExpenseRepository>()

}